const documentReviewV2Es = {
  // Page header
  "Document Review": "Revisión de documentos",
  "Viewing Document": "Visualizando documento",
  "Editing Document": "Editando documento",
  "Confidence Score": "Puntuación de confianza",

  // Three-dot menu
  "View Original Document": "Ver documento original",
  "Download Document": "Descargar documento",
  "Download document": "Descargar documento",
  "Download JSON": "Descargar JSON",
  "View Accounting Period": "Ver período contable",
  "Show Hidden Fields": "Mostrar campos ocultos",
  "Delete Document": "Eliminar documento",
  "Send For Approval": "Enviar para aprobación",

  // Toolbar
  "Show document viewer": "Mostrar visor de documentos",
  "Hide document viewer": "Ocultar visor de documentos",
  History: "Historial",
  Notes: "Notas",
  rotate: "Rotar",
  zoom_out: "Alejar",
  zoom_in: "Acercar",
  capture_field: "Capturar campo",
  capture_field_banner_text:
    "Arrastre o dibuje un cuadro alrededor del valor para copiarlo en el campo resaltado",
  capture_field_close: "Cerrar",
  capture_select_field_first:
    "Seleccione primero un campo o celda y luego arrastre sobre el valor",
  capture_scanning_document: "Escaneando documento...",

  // Document viewer
  "Unable to load document": "No se puede cargar el documento",
  "The document could not be retrieved. Please try again.":
    "No se pudo recuperar el documento. Por favor, inténtelo de nuevo.",

  // Header actions
  "Re-review Document to Update Details": "Volver a revisar el documento para actualizar detalles",
  "Update details": "Actualizar detalles",
  "Re-Process Document": "Reprocesar documento",

  // Right panel
  "Edit Mode is Currently Active": "El modo de edición está activo",
  "Save Changes": "Guardar cambios",
  "Extraction Rules": "Reglas de extracción",
  "Auto Mapping": "Mapeo automático",
  is_being_reviewed: "En revisión",

  // Tabs
  "General Info": "Información general",
  "Line Items": "Artículos de línea",
  Coding: "Codificación",
  "No coding lines yet": "Aún no hay líneas de codificación",
  Amount: "Importe",

  // Validation bar
  Mandatory: "Obligatorios",
  "Fields Required": "Campos requeridos",
  "Mandatory Field": "Campo obligatorio no extraído",
  Discrepancies: "Discrepancias detectadas",
  Fix: "Corregir",
  View: "Ver",

  // PostProcessing section labels
  "Supplier Details": "Detalles del proveedor",
  "Customer Details": "Detalles del cliente",
  "Company Details": "Detalles de la empresa",

  entity_supplier: "Proveedor",
  entity_payment_term: "Condición de pago",
  entity_payment_method: "Método de pago",
  entity_customer: "Cliente",
  entity_company: "Empresa",
  entity_status_unresolved: "No resuelto",
  entity_status_mismatched: "No coincide",
  entity_status_matched_warning: "Coincide con advertencia",
  new_supplier_for_company: "Nuevo proveedor para esta empresa",
  supplier_new_supplier_for_company: "Nuevo proveedor para esta empresa",
  new_customer_for_company: "Nuevo cliente para esta empresa",
  customer_new_customer_for_company: "Nuevo cliente para esta empresa",
  vatid_doesnt_match: "El NIF/IVA no coincide",
  supplier_vatid_doesnt_match: "El NIF/IVA del proveedor no coincide",
  customer_vatid_doesnt_match: "El NIF/IVA del cliente no coincide",
  company_reference_not_found: "No se encontró la referencia de la empresa",
  reference_not_found: "Referencia no encontrada",
  supplier_reference_not_found: "Referencia del proveedor no encontrada",
  customer_reference_not_found: "Referencia del cliente no encontrada",
  not_registered_for_company: "No registrado para esta empresa",
  supplier_not_registered_for_company: "Proveedor no registrado para esta empresa",
  customer_not_registered_for_company: "Cliente no registrado para esta empresa",
  update_account_class_to_edit: "Actualice primero la clase de cuenta para poder editar",
  supplier_permission_required: "Se requiere permiso de proveedores",
  customer_permission_required: "Se requiere permiso de clientes",
  company_permission_required: "Se requiere permiso de empresas",
  Document: "Documento",

  // Field actions
  "Not Found": "No encontrado",
  "View Mapping Logs": "Ver registros de mapeo",
  remove_field: "Eliminar campo",
  "Remove Field": "Eliminar campo",
  "Are you sure you want to remove this field? This action cannot be undone.":
    "¿Estás seguro de que quieres eliminar este campo? Esta acción no se puede deshacer.",

  // Line items table
  Expand: "Expandir",
  "No data available": "No hay datos disponibles",
  "Enter edit mode to add rows": "Entra en modo edición para agregar filas",

  // Editable table
  Actions: "Acciones",
  "Duplicate row": "Duplicar fila",
  "Delete row": "Eliminar fila",
  "Delete Row": "Eliminar fila",
  "You do not have permission to update coding": "No tienes permiso para actualizar la codificación",
  "Total coding amount ({{sum}}) cannot exceed the invoice total without tax ({{amount}})":
    "El importe total de codificación ({{sum}}) no puede superar el total de la factura sin impuestos ({{amount}})",
  "Total coding amount ({{sum}}) is less than the invoice total without tax ({{amount}})":
    "El importe total de codificación ({{sum}}) es menor que el total de la factura sin impuestos ({{amount}})",
  "Are you sure you want to remove this row? This action cannot be undone.":
    "¿Estás seguro de que quieres eliminar esta fila? Esta acción no se puede deshacer.",
  "Delete Selected": "Eliminar seleccionados",
  "Delete Rows": "Eliminar filas",
  "Are you sure you want to remove the selected rows? This action cannot be undone.":
    "¿Estás seguro de que quieres eliminar las filas seleccionadas? Esta acción no se puede deshacer.",
  "Add New Items": "Agregar nuevos elementos",
  "Row Number(Optional)": "Número de fila (opcional)",
  "No of Items (Optional)": "Número de elementos (opcional)",
  "No rows yet — click": "Aún no hay filas — haga clic en",
  "below.": "abajo.",
  Add: "Agregar",

  // History panel
  "Document History": "Historial del documento",
  "No history available": "No hay historial disponible",
  "State Changed": "Estado cambiado",
  "Failure Reason": "Motivo de fallo",
  "Failed Integration": "Integración fallida",
  Rejected: "Rechazado",
  Reviewed: "Revisado",
  Uploaded: "Cargado",

  // Delete document
  "Document deleted successfully": "Documento eliminado correctamente",
  "Are you sure you want to delete this document? This action cannot be undone.":
    "¿Estás seguro de que quieres eliminar este documento? Esta acción no se puede deshacer.",

  // Document status chip (from enum.json documentStatus)
  Awaiting: "En espera",
  Processed: "Procesado",
  Failed: "Fallido",
  Error: "Error",
  "Needs Review": "Necesita revisión",
  Duplicate: "Duplicado",

  // Notes panel
  "Document Notes": "Notas del documento",
  "Post comment": "Publicar comentario",
  "Add a comment": "Añadir un comentario",
  delete_note: "Eliminar nota",
  delete_note_title: "Eliminar nota",
  delete_note_confirmation:
    "¿Estás seguro de que quieres eliminar esta nota? Esta acción no se puede deshacer.",

  // Mandatory fields modal
  "Mandatory Fields Missing": "Campos obligatorios faltantes",
  "General Fields missing": "Campos generales faltantes",
  "Line Item Fields missing": "Campos de artículos faltantes",
  "No missing general fields": "No hay campos generales faltantes",

  // Review required modal
  "Delete Table": "Eliminar tabla",
  "Are you sure you want to delete this table? This action cannot be undone.": "¿Estás seguro de que quieres eliminar esta tabla? Esta acción no se puede deshacer.",
  "Review Required Fields": "Campos que requieren revisión",
  "fields require review": "campos requieren revisión",
  "No review required fields": "No hay campos que requieran revisión",
  "Review Required": "Revisión requerida",
  Review: "Revisión",
  Required: "Requerida",
  "No missing fields": "No hay campos faltantes",
  "Enter value": "Ingrese el valor",
  Row: "Fila",
  "rows found": "filas encontradas",
  Update: "Actualizar",

  // Accounting period modal
  "This period is used for accounting purposes": "Este período se utiliza para fines contables",
  "Open Date": "Fecha de apertura",
  "Close Date": "Fecha de cierre",
  "Close period": "Cerrar período",
  "Close accounting period": "Cerrar período contable",
  "Are you sure you want to close the accounting period? Once the period is closed, all documents for that period will be non-editable.":
    "¿Estás seguro de que quieres cerrar el período contable? Una vez cerrado, todos los documentos de ese período no serán editables.",

  // Mapping logs modal
  "Mapping Logs": "Registros de mapeo",
  "View different mappings applied to field to assign value":
    "Ver los diferentes mapeos aplicados al campo para asignar valor",
  "Updated from": "Actualizado desde",
  "To New Value": "Al nuevo valor",
"Mandatory Fields Label Tooltip": "Verifique el modo de visualización del documento para ver los valores actualizados de los campos de artículos de línea",
  "Mandatory Fields Label Description": "Algunos campos faltantes de los artículos de línea pueden haberse resuelto mediante mapeo o postprocesadores.",
  "Edit Mode Label": "Los valores actualizados mediante el mapeo y los posprocesadores son visibles en el modo de visualización de documentos",
  "Edit Mode Label Tooltip": "Seleccione el modo de visualización del documento para ver los valores finales",
  coding_lines_total_mismatch: "Discrepancia en el total de las líneas de codificación",
  document_total_without_tax_unavailable: "El total del documento sin impuestos no está disponible",
  coding_lines_total_unparseable: "No se pudo interpretar el total de las líneas de codificación",
  classify_document_first:
    "Clasifique primero este documento seleccionando su Clase de cuenta y su Clase de documento.",
  master_data: "Datos maestros",
  master_item: "Artículo",
  master_tax: "Impuesto",
  master_purchase_order_line: "Línea de pedido",
  master_delivery_note_line: "Línea de albarán",
  master_grn_line: "Línea de albarán de recepción",
  master_document_number: "Número de documento",
  master_line: "Línea",
  item_permission_required: "Se requiere permiso de artículos",
  tax_permission_required: "Se requiere permiso de impuestos",
  standard_review_external_document:
    "Los documentos externos no se pueden revisar aquí.",
  standard_review_po_invoice: "Factura con pedido de compra",
  standard_review_non_po_invoice: "Factura sin pedido de compra",
  standard_review_po_not_found: "Pedido de compra no encontrado",
  standard_review_includes_services: "Incluye servicios",
  standard_review_includes_items: "Incluye artículos",
  standard_review_review_item_type: "Revisar el tipo de artículos",
  no_preview_available: "Vista previa no disponible",
  item_lines_reference_missing: "Falta la referencia en las líneas de artículos",
  standard_viewing_AccountPayable: "Visualizando documento: {{documentClass}} por pagar",
  standard_editing_AccountPayable: "Editando documento: {{documentClass}} por pagar",
  standard_viewing_AccountReceivable: "Visualizando documento: {{documentClass}} por cobrar",
  standard_editing_AccountReceivable: "Editando documento: {{documentClass}} por cobrar",
  standard_viewing_unclassified: "Visualizando documento sin clasificar",
  standard_editing_unclassified: "Editando documento sin clasificar",

  // Revisión estándar (/standard GET/PUT): claves de error. Dinámicas: {{0}} = Values[0]
  document_review_docclass_required: "La clase de documento es obligatoria.",
  document_review_docclass_shouldbe_oneof:
    "La clase de documento no es un tipo de documento válido.",
  standard_review_docclass_unknown:
    "La clase de documento no puede ser Desconocida. Seleccione una clase de documento.",
  standard_review_accountclass_required: "La clase de cuenta es obligatoria.",
  standard_review_accountclass_shouldbe_oneof:
    "La clase de cuenta debe ser Cuentas por pagar o Cuentas por cobrar.",
  system_being_updated:
    "El sistema se está actualizando. Inténtelo de nuevo en unos minutos.",
  organization_standardization_disable:
    "La estandarización está deshabilitada para su organización.",
  organization_asyncreview_disable:
    "La revisión asíncrona está deshabilitada para su organización.",
  standard_review_form_not_supported:
    "Los documentos creados desde un formulario no se pueden revisar aquí.",
  standard_review_coding_not_applicable:
    "Las líneas de codificación solo se pueden añadir a facturas de servicios sin pedido de compra (Cuentas por pagar).",
  standard_review_company_required: "La empresa es obligatoria.",
  standard_review_supplier_required:
    "El proveedor es obligatorio para documentos de Cuentas por pagar.",
  standard_review_customer_required:
    "El cliente es obligatorio para documentos de Cuentas por cobrar.",
  standard_review_invalid_number: `"{{0}}" debe estar vacío o ser un número válido. Los campos de número entero solo aceptan enteros; los decimales usan "." sin separadores de miles (p. ej. 1234.56).`,
  standard_review_company_not_found: "No se encontró la empresa '{{0}}'.",
  standard_review_supplier_not_found: "No se encontró el proveedor '{{0}}'.",
  standard_review_customer_not_found: "No se encontró el cliente '{{0}}'.",
  standard_review_paymentterm_not_found:
    "No se encontró la condición de pago '{{0}}'.",
  standard_review_paymentmethod_not_found:
    "No se encontró el método de pago '{{0}}'.",
  standard_review_supplier_not_allowed:
    "El proveedor '{{0}}' no está permitido en un documento de Cuentas por cobrar.",
  standard_review_customer_not_allowed:
    "El cliente '{{0}}' no está permitido en un documento de Cuentas por pagar.",
  standard_review_item_not_found: "No se encontró el artículo '{{0}}'.",
  standard_review_tax_not_found: "No se encontró el impuesto '{{0}}'.",
  standard_review_dimension_not_found: "No se encontró la dimensión '{{0}}'.",
  standard_review_dimension_value_not_found:
    "No se encontró el valor de dimensión '{{0}}'.",
  standard_review_dimension_value_mismatch:
    "El valor de dimensión '{{0}}' no pertenece a la dimensión seleccionada.",
  standard_review_line_not_found:
    "No se encontró la línea '{{0}}' en este documento.",
  standard_review_line_type_mismatch:
    "La línea '{{0}}' pertenece a otro tipo de línea.",
  standard_review_duplicate_line: "La línea '{{0}}' se envió más de una vez.",
  document_review_not_found: "No se encontró el documento '{{0}}'.",
  review_document_include_schedulepaymentbill:
    "Este documento no se puede revisar porque está incluido en la factura de pago programado '{{0}}'.",
};

export default documentReviewV2Es;
